import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loadingGif from './../../../../../../assets/images/loading.gif';
import AddRestaurant from './../../../../../restaurantsetup/components/AddRestaurantDialog/AddRestaurantDialog.tsx';
import FoodDeliveryLoader from '../../../../../components/LoadingView/FoodDeliveryLoder.js';
function SchedularPreview(props) {
  const apiAddress = process.env.REACT_APP_SECRET;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [LastOrderTime, setLastOrderTime] = useState({});
  const [confirmedLastOrderTimes, setConfirmedLastOrderTimes] = useState([]);
  const { showLastOrderTime } = props;
  const { showSchedulerTable } = props;
  const { selecteditem } = props;
  const { resSaveClicked } = props;
  console.log(selecteditem);
  console.log(resSaveClicked);

  useEffect(() => {
    //props.addHandleSelect("Return")
    handleConfirm()
  }, [resSaveClicked]);

  useEffect(() => {
    //props.addHandleSelect("Return")
    handleConfirm()
  }, [LastOrderTime]);

  useEffect(() => {
    if (selecteditem?.length > 0) {
      const initialTimes = {};
      selecteditem.forEach((item) => {
        if (item.getLastOrderTimes?.length > 0) {
          item.getLastOrderTimes.forEach((orderTime) => {
            initialTimes[orderTime.scheduleDateTimeId] =
              orderTime.scheduleLastOrderTime;
          });
        }
      });
      setLastOrderTime(initialTimes);
    }
  }, [selecteditem]);

  const handleTime = (ev, scheduleId, scheduleDateTimeId) => {
    const newTime = ev.target.value;
    setLastOrderTime((prevState) => ({
      ...prevState,
      [scheduleDateTimeId]: newTime,
    }));
  };

  const handleConfirm = () => {
    console.log('hit')
    const lastOrderTimelist = [];

    data.forEach((scheduler) => {
      scheduler.scheduleDateTimes.forEach((scheduleDateTime) => {
        const lastOrderTime =
          LastOrderTime[scheduleDateTime.scheduleDateTimeId];

        lastOrderTimelist.push({
          Id: '',
          RestaurantId: '',
          ScheduleDateTimeId: scheduleDateTime.scheduleDateTimeId,
          LastOrderTime: lastOrderTime,
          CreatorId: '678',
          CreationDate: new Date(),
          ModifierId: '56',
          ModificationDate: new Date(),
          ScheduleId: scheduler.scheduleInfo.scheduleId,
        });
      });
    });

    props.addHandleSelect(lastOrderTimelist);
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const responses = await Promise.all(
        props.selectedId.map((dt) =>
          axios.get(apiAddress + `/api/Schedule/getschedulebyid?id=${dt.id}`)
        )
      );
  
      let scheduleData = responses.map((response) => response.data);
      // Merge scheduleDays into scheduleDateTimes
      scheduleData = scheduleData.map((schedule) => {
        return {
          ...schedule,
          scheduleDateTimes: schedule.scheduleDateTimes.map((dateTime) => {
            return {
              ...dateTime,
              scheduleDays: schedule.scheduleDays.find(
                (day) => day.scheduleDateTimeId === dateTime.scheduleDateTimeId
              ),
            };
          }),
        };
      });
  
      if (scheduleData.some((data) => data === '')) {
        toast.error('Some schedules returned no data.', {
          position: 'top-right',
          autoClose: 5000,
        });
      } else {
        setData(scheduleData);
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to load schedule data.', {
        position: 'top-right',
        autoClose: 5000,
      });
    } finally {
      setLoading(false);
    }
  };
  



  useEffect(() => {
    setLoading(true);
    loadData();
  }, [props]);

  const getDays = (scheduleDateTimeId, index) => {
    const obj = data[index].scheduleDays.find(
      (x) => x.scheduleDateTimeId === scheduleDateTimeId
    );
    const days = [];
    if (obj?.isFriday) days.push('FRI');
    if (obj?.isMonday) days.push('MON');
    if (obj?.isSaturday) days.push('SAT');
    if (obj?.isSunday) days.push('SUN');
    if (obj?.isThursday) days.push('THURS');
    if (obj?.isWednesday) days.push('WED');
    if (obj?.isTuesday) days.push('TUES');
    return days.join(', ');
  };

  const getDate = (props) => {
    const d = new Date(props);
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  };

  return (
    <div>
      <ToastContainer />
      <Grid container>
        {loading ? (
          <FoodDeliveryLoader/>
        ) : (
          showSchedulerTable &&
          data?.length > 0 &&
          data?.map((mainDT, i) => (
            <Grid item xs={12} key={i} style={{ paddingTop: '0.8rem' }}>
              {mainDT?.scheduleDateTimes.length > 0 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align='center'
                        sx={{ backgroundColor: '#939193' }}
                      >
                        Scheduler Name
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{ backgroundColor: '#939193' }}
                      >
                        Scheduler Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        align='center'
                        style={{ fontSize: '1rem' }}
                        rowSpan={mainDT.scheduleDateTimes.length + 1}
                      >
                        {mainDT.scheduleInfo.scheduleName}
                      </TableCell>
                      <TableCell>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell
                                align='center'
                                sx={{ backgroundColor: '#939193' }}
                                width={200}
                              >
                                Date / Day
                              </TableCell>
                              <TableCell
                                align='center'
                                sx={{ backgroundColor: '#939193' }}
                                width={200}
                              >
                                Time
                              </TableCell>
                              {showLastOrderTime && (
                                <TableCell
                                  align='center'
                                  sx={{ backgroundColor: '#939193' }}
                                  width={200}
                                >
                                  Last Order Time
                                </TableCell>
                              )}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {mainDT.scheduleDateTimes.map((dt, index) => (
                              <TableRow key={index}>
                                <TableCell align="center">
                                  {dt.isDays && dt.scheduleDays ? (
                                    <div className="d-flex" style={{ gap: '2px', justifyContent: 'center' }}>
                                      
                                      <button className={`circleBtn ${dt.scheduleDays.isSunday ? 'colorSelected' : 'colorNotSelected'}`}>
                                        S
                                      </button>
                                      <button className={`circleBtn ${dt.scheduleDays.isMonday ? 'colorSelected' : 'colorNotSelected'}`}>
                                        M
                                      </button>
                                      <button className={`circleBtn ${dt.scheduleDays.isTuesday ? 'colorSelected' : 'colorNotSelected'}`}>
                                        T
                                      </button>
                                      <button className={`circleBtn ${dt.scheduleDays.isWednesday ? 'colorSelected' : 'colorNotSelected'}`}>
                                        W
                                      </button>
                                      <button className={`circleBtn ${dt.scheduleDays.isThursday ? 'colorSelected' : 'colorNotSelected'}`}>
                                        T
                                      </button>
                                      <button className={`circleBtn ${dt.scheduleDays.isFriday ? 'colorSelected' : 'colorNotSelected'}`}>
                                        F
                                      </button>
                                      <button className={`circleBtn ${dt.scheduleDays.isSaturday ? 'colorSelected' : 'colorNotSelected'}`}>
                                        S
                                      </button>
                                    </div>
                                  ) : (
                                    <>
                                      {new Date(dt.fromDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                      })}{' '}
                                      -{' '}
                                      {new Date(dt.toDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                      })}
                                    </>
                                  )}
                                </TableCell>

                                <TableCell align='center'>
                                  {dt.isAllDay ? (
                                    <>All Day</>
                                  ) : (
                                    <>
                                      {new Date(
                                        '1970-01-01T' + dt.fromTime
                                      ).toLocaleTimeString('en-US', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true,
                                      })}{' '}
                                      -{' '}
                                      {new Date(
                                        '1970-01-01T' + dt.toTime
                                      ).toLocaleTimeString('en-US', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true,
                                      })}
                                    </>
                                  )}
                                </TableCell>
                                {showLastOrderTime && (
                                  <TableCell align='center' width={200}>
                                    <input
                                      type='time'
                                      id={`last-order-times-${dt.scheduleDateTimeId}-${index}`}
                                      className='form-control'
                                      value={
                                        LastOrderTime[dt.scheduleDateTimeId] ||
                                        ''
                                      }
                                      onChange={(ev) =>
                                        handleTime(
                                          ev,
                                          mainDT.scheduleInfo.scheduleId,
                                          dt.scheduleDateTimeId
                                        )
                                      }
                                    />
                                  </TableCell>
                                )}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              ) : (
                <p>Nothing found</p>
              )}
              <hr />
            </Grid>
          ))
        )}
      </Grid>
      {/* {showSchedulerTable && data.length > 0 && showLastOrderTime && (
        <Grid container justifyContent='flex-end' sx={{ marginTop: '1rem' }}>
          <Button variant='contained' color='primary' onClick={handleConfirm}>
            Confirm Last Order Times
          </Button>
        </Grid>
      )}
      <AddRestaurant returnValue={confirmedLastOrderTimes} /> */}
    </div>
  );
}

export default SchedularPreview;
